// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1Tevv","clinicsSelect":"TableHeading_clinicsSelect__hSnU2"};